/** 建站 PDF 指定域名与品牌 */
export const SITE_ORIGIN = 'https://gbwhtas.com';
export const SITE_NAME = 'GBWhatsApp';

export const LOCALES = [
{ code: 'en', path: '', hreflang: 'en', label: 'English' },
	{ code: 'in', path: 'in', hreflang: 'hi', label: 'हिन्दी' },
	{ code: 'es', path: 'es', hreflang: 'es', label: 'Español' },
	{ code: 'pt', path: 'pt', hreflang: 'pt', label: 'Português' },
	{ code: 'id', path: 'id', hreflang: 'id', label: 'Indonesia' },
];
